import { apiSauce } from "../sagas/";
import store from "../reducers/";
import { path } from "ramda";
import ModalUtil from "../util/modal";
// import OrganizationAction from '../reducers/OrganizationReducer'
import queue from "async/queue";


const changePassword = (payload) => new Promise((resolve) => {

	const { token } = store.getState().authen;
	const packPayload = { headers: {token} , payload };
	try {
		// store.dispatch(OrganizationAction.setOrganizationLoadingRequest())
		apiSauce.changePassword(packPayload).then((res) => {
			const data = path(["data", "data"], res);
			if (res.ok && data) {
				ModalUtil.showSuccess("Change Password successfully");
				resolve(true);
			} else {
				ModalUtil.showError(res);
				// store.dispatch(OrganizationAction.setOrganizationLoadingFinish())
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		// store.dispatch(OrganizationAction.setOrganizationLoadingFinish())
		resolve(false);
	}
});


const forgotPassword = (payload) => new Promise((resolve) => {
	const packPayload = { payload };
	try {
		apiSauce.forgotPassword(packPayload).then((res) => {
			// console.log(res)
			if (res.ok && res.data) {
				ModalUtil.showSuccess("Password reset email has been sent to your inbox");
				resolve(true);
			} else {
				ModalUtil.showError(res);
				resolve(false);
			}
		});
	} catch (e) {
		ModalUtil.showDefaultError();
		resolve(false);
	}
});


export { changePassword, forgotPassword };



// WEBPACK FOOTER //
// ./src/actions/UserAction.js